<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>{{ currentActionState('approveQualificationTimeModal') ? 'GODKÄNN KVALIFICERINGSTID' : 'ÄNDRING AV KVALIFICERINGSTID'}}</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="close()">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="">
        <v-row no-gutters>
          <v-col cols="3">
            <p class="overline">ÄNDRING GÄLLER</p>
            <p class="mt-n3" v-if="selectedPerson">
              <router-link :to="'/people/' + selectedPerson.id">{{ selectedPerson | fullName }}</router-link>
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">PERSONNUMMER</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.personalNumber">
              {{ selectedPerson.personalNumber | formatPnr }}
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">MOBILNUMMER</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.mobilephone">
              <a :href="`tel:${selectedPerson.mobilephone}`"> {{ selectedPerson.mobilephone }}</a>
            </p>
          </v-col>
          <v-col cols="3"
            ><p class="overline">E-POSTADRESS</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.email">
              <a :href="`mailto:${selectedPerson.email}`"> {{ selectedPerson.email }}</a>
            </p>
          </v-col>

          <v-col cols="12">
            <p class="overline mt-3">STARTDATUM</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="QTM && QTM.fromDate">
                {{ get(QTM, 'fromDate', new Date('Startdatum saknas')) | date }}
              </p>
            </div>
          </v-col>
          <v-col cols="12" v-if="!currentActionState('approveQualificationTimeModal')">
            <p class="overline mt-3">TIDIGARE LÄNGD PÅ KVALIFICERINGSTIDEN FÖRE ÄNDRING</p>
            <div class="d-flex">
              <p class="mt-n3">
                {{ initialQualifyingLength }} månader
              </p>
            </div>
          </v-col>

          <template v-if="!currentActionState('approveQualificationTimeModal')">
            <v-col cols="12" v-if="editQualificationLength == false"
              ><p class="overline mt-3">NY LÄNGD PÅ KVALIFICERINGSTIDEN EFTER ÄNDRING</p>
              <div class="d-flex">
                <template v-if="QTM && QTM.lengthInMonths" >
                  <p class="mt-n3">
                    {{ calculatedQualifyingLength }} månader
                  </p>
                  <v-btn class="ml-n6 mt-n7" @click="editQualificationLength = true" text :disabled="isDisabled || !canUpdate">
                    <v-icon small>$sl-edit</v-icon>
                  </v-btn>
                </template>
                <template v-else>
                  <p class="mt-n3">Avbruten</p>
                </template>
              </div>
            </v-col>
            <v-col cols="6" v-else>
              <v-select
                v-model="qualificationLength"
                :items="timesLengths"
                outlined
                item-text="text"
                item-value="id"
                return-object
                label="Kvalificeringstidens längd"
                clearable
              ></v-select>
            </v-col>
          </template>
          <v-col cols="6"></v-col>
          <v-col cols="12">
            <p class="overline text-uppercase mt-3">Slutdatum inklusive eventuell förlängning på grund av uppehåll</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="QTM && QTM.toDate">
                {{ finalEndDate | date }}
              </p>
            </div>
          </v-col>

          <v-col cols="6">
            <v-btn
              color="secondary"
              class="icon"
              @click="
                $nextTick(() =>
                  $router
                    .push({name: 'PersonDetail', params: {id: selectedPerson.id}, query: {tab: '5'}})
                    .catch(() => {})
                )
              "
            >
              <v-icon>$sl-stairs-ascend</v-icon>Visa personens kvalificeringstid
            </v-btn>
          </v-col>
          <v-col cols="6">
            <p class="overline text-uppercase mt-3">
              <v-icon class="special-icon-size mr-1">$sl-info</v-icon
              ><a
                href="https://www.byggbranschensyrkesnamnd.se/om-byn/yrkesutbildningsavtal/yua-2020-avtal-och-anvisningar/"
                target="blank"
                >Beräkning av kvalificeringstid</a
              >
            </p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col cols="6"
            ><p class="overline text-uppercase mt-3">Godkänd av (1)</p>

            <p class="mt-n3" v-if="QTM && QTM.approvedBy">
              {{ QTM.approvedBy | fullName }}
              <span v-if="QTM.approvedAt">({{ QTM.approvedAt | date }})</span>
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
          <v-col cols="6"
            ><p class="overline mt-3 text-uppercase">Godkänd av (2)</p>
            <p class="mt-n3" v-if="QTM && QTM.approvedBySecondary">
              {{ QTM.approvedBySecondary | fullName }}
              <span v-if="QTM.approvedBySecondaryAt">({{ QTM.approvedBySecondaryAt | date }})</span>
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="currentActionState('approveQualificationTimeModal')">
        <MessageBox>
          <p>
            När kvalificeringstiden har godkänts av två regionärer 
            kommer ett Yrkesbevis att automatiskt utfärdas och skickas på tryck.
          </p>
        </MessageBox>
      </v-card-text>

      <v-card-actions class="justify-end mt-2">
        <v-btn color="secondary" @click="close()"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
        <v-btn v-if="!currentActionState('approveQualificationTimeModal')"
          outlined 
          @click="deleteQTM()" 
          :disabled="deleteActionIsDisabled"
        >
          <v-icon>$sl-delete</v-icon>Radera
        </v-btn>

        <v-btn v-if="!currentActionState('approveQualificationTimeModal')"
          @click="deny()" 
          color="secondary" 
          :disabled="isButtonsDisabled || isEditMode || QTM.isApproved || !canUpdate" 
        >
          <v-icon>$sl-dislike</v-icon>Neka
        </v-btn>

        <v-btn v-if="isEditMode == true"
          @click="update()" 
          :disabled="QTM.isApproved || !canUpdate" 
        >
          <v-icon>$sl-check</v-icon>Spara och Godkänn
        </v-btn>

        <v-btn v-else
          @click="approve()" 
          :disabled="isButtonsDisabled || QTM.isApproved || !canUpdate" 
        >
          <v-icon>$sl-like</v-icon>Godkänn
        </v-btn>

        <v-btn v-if="canUndoApprove" 
          @click="undoApprove()"><v-icon>$sl-cancel</v-icon>Ångra
        </v-btn>
      </v-card-actions>
      <p v-if="isSameUserApproved" class="info-text mt-4 pr-10">
        <i
          ><b>Obs:</b> Du har godkänt den här anmälan. Det krävs att en annan regionär kontragodkänner för att anmälan
          ska godkännas fullständigt.</i
        >
      </p>
    </v-form>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters} from 'vuex'
import {Regions, RulesMixin, UserRules, CanIDo} from '@/components/mixins'
import MessageBox from '../../common/MessageBox.vue'
import get from 'lodash/get'

export default {
  mixins: [Regions, RulesMixin, UserRules, CanIDo],
  components: { MessageBox },
  props: {
    // Person object with a default value
    QTM: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    },
    paused: {
      type: Array,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      isDisabled: false,
      editQualificationLength: false,
      oldQualificationLength: false,
      qualificationLength: '',
      timesLengths: [],
      isApproved: false,
    }
  },
  watch: {
    QTM() {
      this.init()
    }
  },

  created() {
    this.init()
  },
  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('basic', ['getQualificationLengthItems', 'getProfessionById', 'getRegionById']),

    currentActionState() {
      return state => this.QTM.actions.includes(state)
    },

    isButtonsDisabled() {
      let approvedById = null
      if (this.QTM && this.QTM.approvedById) {
        approvedById = this.QTM.approvedById
      }
      if (
        !this.canUserApprove(this.QTM.regionId, approvedById) ||
        (this.QTM && this.QTM.approved == true) ||
        (this.QTM && this.QTM.rejectedById && this.QTM.rejectedById > 0)
      ) {
        return true
      } else return false
    },
    isEditMode() {
      if (this.editQualificationLength == true) return true
      else return false
    },
   
    isSameUserApproved() {
      if (this.QTM && this.QTM.approvedBySecondaryId && this.QTM.approvedBySecondaryId > 0) {
        return false
      } else if (this.QTM && this.QTM.approvedById && this.QTM.approvedById > 0) {
        if (this.currentUser && this.currentUser.id == this.QTM.approvedById) {
          return true
        }
      }
      return false
    },
    finalEndDate() {
      let fromDate = new Date(get(this, 'QTM.qualificationTimeToDate', new Date('1970-01-01')))
      let pausedDates = 0
      /* qualificationTimeModifications replace with new uppehål object */
      if (this.paused && this.paused.length > 0) {
        this.paused.forEach(pause => {
          pausedDates += this.monthDiff(new Date(pause.fromDate), new Date(pause.toDate))
        })
      }
      let finalTime
      /* Plus all paused that he has to be added */
      if (this.qualificationLength && this.qualificationLength.value) {
        finalTime = this.qualificationLength.value + pausedDates
        return fromDate.setMonth(fromDate.getMonth() + finalTime)
      } else {
        if ( get(this, 'QTM.overwrite', false) || this.calculatedLength < this.initialQualifyingLength )
          return get(this, 'QTM.toDate', new Date('1970-01-01'))

        return fromDate.setMonth(fromDate.getMonth() + get(this, 'QTM.lengthInMonths', 0))
      }
    },

    initialQualifyingLength() {
      return this.monthDiff(
        new Date(get(this, 'QTM.qualificationTimeFromDate', new Date('1970-01-01'))),
        new Date(get(this, 'QTM.qualificationTimeToDate', new Date('1970-01-01')))
      )
    },

    calculatedQualifyingLength() {
      if ( this.calculatedLength < this.initialQualifyingLength )
        return get(this, 'QTM.lengthInMonths', 0)

      if ( get(this, 'QTM.overwrite', false) ) 
        return get(this, 'QTM.lengthInMonths', 0)

      return this.initialQualifyingLength + get(this, 'QTM.lengthInMonths', 0)
    },

    calculatedLength() {
      if ( !get(this, 'QTM.companyModification', 0) )
        return get(this, 'QTM.lengthInMonths', 0)

      if ( get(this, 'QTM.overwrite', false) )
        return get(this, 'QTM.lengthInMonths', 0)

      return this.initialQualifyingLength + get(this, 'QTM.lengthInMonths', 0)
    },
    
    canUndoApprove(){
      return this.QTM && this.QTM.approvedById && this.QTM.approvedById === this.currentUser.id && !this.QTM.approvedBySecondaryId;
    },

    roleIsAdmin() {
      return get(this, 'currentUser.userrole.isAdmin', false)
    },

    deleteActionIsDisabled() {
      return (!this.roleIsAdmin || !this.canUpdate) && this.isDisabled
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('education', 'update');
    },
  },

  methods: {

    get,

    init() {
      this.timesLengths=this.getQualificationLengthItems

      if (
        (this.QTM && this.QTM && this.QTM.approved == true) ||
        this.canApprove == false ||
        (this.QTM && this.QTM && this.QTM.rejectedById && this.QTM.rejectedById > 0)
      ) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
    monthDiff(d1, d2) {
      var months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    },
    async deleteQTM() {
      const res = await this.$dialog.confirm({
        text: 'Radering går inte att ångra.',
        title: 'Är du säker på att du vill radera denna ändring?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })
      if (res !== true) return

      API.deletePersonQualificationTimeModification(this.QTM.id)
        .then(res => {
          this.$events.fire('showInfo', 'Ändring av kvalificeringstid är raderad')

          this.$emit('close')
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    async deny() {
      const res = await this.$dialog.confirm({
        title: 'Är du säker på att du vill neka denna ändring?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Neka', key: true, icon: '$sl-dislike', outlined: true}
        ]
      })
      if (res !== true) return

      API.denyPersonQualificationTimeModification(this.QTM.id)
        .then(res => {
          this.$events.fire('showInfo', 'Ändring av kvalificeringstid är nekad.')
          this.QTM.rejectedById = this.currentUser.id
          this.QTM.rejectedAt = new Date()
          this.isDisabled = true
          this.$emit('close')
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    //update the form and remove all approvements. After saved, needs to be approved by 2 different persons.
    async update() {
      if (!this.$refs.form.validate() || !(this.QTM && this.QTM.id)) {
        return this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
      }

      this.QTM.approvedBy = null
      this.QTM.approvedById = null
      this.QTM.approvedAt = null
      if (this.qualificationLength) {
        this.QTM.newLengthInMonths = this.initialQualifyingLength + this.qualificationLength.value
      }

      await API.updatePersonQualificationTimeModification(this.QTM.id, {
        data: this.QTM
      })
        .then(res => {
          this.approve()
          this.$events.fire('showInfo', 'Kvalificeringstid sparad.')
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },

    async undoApprove(){
      let apiMethod = 'updatePersonQualificationTimeModification'
      if ( get(this, 'QTM.actions', '') === 'approveQualificationTimeModal' )
        apiMethod = 'updateQualificationTime'

      try {
        await API[apiMethod](this.QTM.id, { data: { approvedAt: null, approvedById: null } })  
      } catch (error) {
        console.log('There was an error:', error)
      } finally {
        this.$emit('close')
      }
    },

    //needs to be approve by 2 persons. Check first if it is approved by a first person.
    async approve() {

      if(this.QTM.actions === 'approveQualificationTimeModal') {

        //- Declare data
        let data = {
          approvedAt: new Date(),
          approvedById: this.QTM.approvedById ?? this.currentUser.id,
        }

        let apiMethod = 'issueQualificationTime'

        if (this.QTM.approvedById && !this.QTM.approvedBySecondaryId) {
          data = {
            approvedBySecondaryId: this.currentUser.id,
            approvedBySecondaryAt: new Date(),
            isApproved: this.QTM.approvedById ? true : false
          }

          apiMethod = 'approveQualificationTime' 
        }

        const person = this.selectedPerson.educations?.find(({ id }) => id === this.QTM.educationId)
        if( !person ) 
          return this.$events.fire('showError', 'Kunde tyvärr inte godkänna Kvalificeringstiden.')

        try {
          await API[apiMethod](this.QTM?.id, { data: data }).then(() => {

            const text = this.QTM.approvedById ? 'Kvalificeringstiden godkänd.' : 'Skickad för godkännande.'
            this.$events.fire('showInfo', text)

            if(!this.QTM.approvedById) return

            const education = this.selectedPerson.educations?.find(edu => edu.id === this.QTM.educationId)
            let professionId
            let machineIds = []

            if(education) {
              professionId = education.professionId
              
              //- Check if person has any machines and include them in Tradecertificate
              const prof = this.getProfessionById(professionId)
              
              if ( prof ) {
                const profMachineOrientations = education.educationProfessionOrientations.map(epo => epo.professionMachineOrientationId)
                machineIds = prof.machineOrientations.filter(mo => profMachineOrientations.includes(mo.id)).map(o => o.machineId)
              }
            } 

            const orderData = {
              personId: this.$route.params.id,
              regionId: this.QTM.regionId,
              professionId: professionId,
              issuedOn: new Date(),
              name: null,
              attention: null,
              address: null,
              address2: null,
              zip: null,
              city: null,
              machineIds: machineIds,
            }

            API.createTradeCertificate({ data: orderData })
            .then((res) => {
              if (data.approvedBySecondaryId) {
                return API.approveTradeCertificate(res.data.id);
              }
            })
            .catch((error) => {
              console.log(error);
            });
          }) 
        } catch (error) {
          this.$events.fire('showError', (get(error, 'response.data', 'Något gick fel vid godkännandet av kvalificeringstiden. Försök igen senare.')))
        }
      }
      
      if( this.QTM.actions === 'qualificationTimeModal' ) {
        await API.approvePersonQualificationTimeModification(this.QTM.id)
        .then(res => {
          //this.close()
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
      }

      this.isDisabled = true
      this.$emit('close')
    },
    //reset the form and close emit to close the modal
    close() {
      //reset the form with the original value
      this.qualificationLength = ''
      this.editQualificationLength = false

      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>